var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, setLoadingPercentage, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { ExportTransactionUtils } from '@popup/steem/utils/export-transactions.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import { FormContainer } from 'src/common-ui/form-container/form-container.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
import { setTitleContainerProperties } from 'src/popup/multichain/actions/title-container.actions';
const ExportTransactions = ({ activeAccount, setTitleContainerProperties, addToLoadingList, removeFromLoadingList, setErrorMessage, setLoadingPercentage, }) => {
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_export_transactions',
            isBackButtonEnabled: true,
        });
    }, []);
    const handleClickOnDownload = () => __awaiter(void 0, void 0, void 0, function* () {
        if (startDate &&
            endDate &&
            new Date(startDate).getTime() > new Date(endDate).getTime()) {
            setErrorMessage('export_transactions_incorrect_dates');
            return;
        }
        addToLoadingList('popup_html_pref_export_transactions_downloading_loading_message');
        try {
            yield ExportTransactionUtils.downloadTransactions(activeAccount.name, 'STEEM', startDate, endDate, (percentage) => {
                setLoadingPercentage(percentage);
            });
        }
        catch (err) {
            const error = err;
            setErrorMessage(error.message, error.messageParams);
        }
        finally {
            removeFromLoadingList('popup_html_pref_export_transactions_downloading_loading_message');
        }
    });
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_EXPORT_TRANSACTIONS}-page`, className: "export-transactions-page" },
        React.createElement("div", { className: "introduction", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_pref_export_transactions_info'),
            } }),
        React.createElement(SelectAccountSectionComponent, { fullSize: true, background: "white" }),
        React.createElement(FormContainer, { onSubmit: handleClickOnDownload },
            React.createElement("div", { className: "form-fields" },
                React.createElement(InputComponent, { onChange: setStartDate, value: startDate, dataTestId: "input-startDate", type: InputType.DATE, placeholder: "popup_html_start_date", label: "popup_html_start_date" }),
                React.createElement(InputComponent, { onChange: setEndDate, value: endDate, dataTestId: "input-endDate", type: InputType.DATE, placeholder: "popup_html_end_date", label: "popup_html_end_date" })),
            React.createElement(ButtonComponent, { label: "popup_html_download", dataTestId: "export-transactions-download", onClick: handleClickOnDownload }))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
    addToLoadingList,
    removeFromLoadingList,
    setErrorMessage,
    setLoadingPercentage,
});
export const ExportTransactionsComponent = connector(ExportTransactions);
